import { render, staticRenderFns } from "./FormularioBarredor.vue?vue&type=template&id=473fe9b9"
import script from "./FormularioBarredor.vue?vue&type=script&lang=ts"
export * from "./FormularioBarredor.vue?vue&type=script&lang=ts"
import style0 from "./FormularioBarredor.vue?vue&type=style&index=0&id=473fe9b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports